import React from 'react';

import upsolveStats from '../../../content/onBuild/upsolveStats';
import { H5 } from '../Type/Display.h';
import P from '../Type/Paragraph.p';

const SidebarAboutUs = () => (
  <div>
    <H5>What is Upsolve?</H5>
    <P>Upsolve is an award winning nonprofit that's funded by the U.S. government, Harvard University, and the Robin Hood Foundation. We have <b>cleared ${upsolveStats.debtCleared.total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} of debt</b> for over a thousand low-income families. Our self-service tool and help is 100% free. <a href="https://my.upsolve.org/screener">See if you qualify and learn more about our chapter 7 bankruptcy tool and process</a>.</P>
  </div>
);

export default SidebarAboutUs;
